import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Deficiences } from "../../models/deficiences";
import { environment } from '../../../environments/environment.prod';

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable({
    providedIn: "root"
})
export class DeficiencesService {
    baseUrl = environment.baseUrl;

    constructor(private http: HttpClient) { }

  createClaimant(claimant: Deficiences): Observable<Deficiences> {
    return this.http.post<Deficiences>(this.baseUrl + "Deficiences", claimant, httpOptions);
    }

    submitDocuments(claimNumber: string, files: File[]): Observable<any> {
      const docOptions = { headers: new HttpHeaders({ "Accept": "application/json" }), params: { claimnumber: claimNumber.toString() } }
      const formData = new FormData();
      if (files && files.length) {
        files.forEach(file => formData.append('files', file));
      }
      return this.http.post<any>(this.baseUrl + "Deficiences/SubmitDocuments", formData, docOptions);
    }
}


export { Deficiences };
